var lib_core = require("lib-core");
var lib_geometry     = require("lib-geometry");

var MasterController = require("./../extensions/master/masterController.js");

var AbstractEditorController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        NODE_MOUSE_DOWN:    {id: 'abs_15', name: "NODE_MOUSE_DOWN"},
        ZOOM_TO_FIT_EDITOR: {id: 'abs_30', name: "ZOOM_TO_FIT_EDITOR"}
    });
};
lib_core.inherit(AbstractEditorController, lib_core.Controller);
AbstractEditorController.inject = {
    masterController : MasterController
};

module.exports = AbstractEditorController;

AbstractEditorController.prototype.afterBuild = function () {
    var self = this;

    // Everything below is needed so that the initial state of the editor is properly recorded.
    // Talk to Karel Bruneel if you want to change this.
    var stateMachineCreator = function(){
        var sm = new lib_core.StateMachine();

        sm.addEventAction("idle",
            function(cEvent) {
                return  cEvent.type() == lib_core.GuiEvents.CANVAS_RESIZE &&
                    cEvent.element("editorModel") === self.getModel();
            },
            function(cEvent) {
                var bbData = cEvent.data("bb");
                var bb = new lib_geometry.BoundingBox(bbData.x, bbData.y, bbData.width, bbData.height);
                cEvent.element("editorModel").canvasRect(bb);
            },
            "resize_editor"
        );

        sm.addEventAction("idle",
            function(cEvent) {
                return  cEvent.type() == lib_core.GuiEvents.ZOOM_TO_FIT_EDITOR &&
                    cEvent.element("editorModel") === self.getModel();
            },
            function(cEvent) {
                //todo There should be a better way to get the zooming model
                var editorModel = cEvent.element("editorModel");
                var cameraModel = editorModel.children.get("camera");
                if (!cameraModel) {console.warn("no camera model"); return;}
                var zoomingModel = cameraModel.children.get("zooming");
                if (!zoomingModel) {console.warn("no zooming model"); return;}
                zoomingModel.zoomToFit();
            },
            "zoom_to_fit_editor"
        );


        return sm;
    };

    this.rootStateMachine.append("window_resize_" + self.getModel().$id, stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);

    this.getView().onResize();

    var cEvent = new lib_core.GuiEvent()
        .type( lib_core.GuiEvents.ZOOM_TO_FIT_EDITOR )
        .scope(this.getModel().scope())
        .element("editorModel", this.getModel());

    this.rootStateMachine.handle(cEvent);

    // Everything above is needed so that the initial state of the editor is properly recorded.
    // Talk to Karel Bruneel if you want to change this.
};
